import axios from "axios";
import { useAuthStore } from "~/stores/auth";

let isRefreshing = false;
let failedQueue: Array<{ resolve: Function; reject: Function }> = [];

function processQueue(error: any, token: string | null = null) {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  failedQueue = [];
}

export function useApi() {
  const { activeBase } = useApiBase();
  const auth = useAuthStore();

  const api = axios.create({
    headers: {
      "Content-Type": "application/json",
    },
  });

  // Base URL dinâmica: no mobile muda conforme a clínica selecionada
  api.interceptors.request.use((cfg) => {
    cfg.baseURL = activeBase.value;
    if (auth.accessToken) {
      cfg.headers.Authorization = `Bearer ${auth.accessToken}`;
    }
    return cfg;
  });

  api.interceptors.response.use(
    (response) => response,
    async (error) => {
      const original = error.config;

      if (error.response?.status === 401 && !original._retry && auth.refreshToken) {
        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
          }).then((token) => {
            original.headers.Authorization = `Bearer ${token}`;
            return api(original);
          }).catch((err) => {
            return Promise.reject(err);
          });
        }

        original._retry = true;
        isRefreshing = true;

        try {
          const { data } = await axios.post(
            `${activeBase.value}/auth/refresh`,
            { refresh: auth.refreshToken }
          );
          auth.setTokens(data.data);
          processQueue(null, data.data.access);
          original.headers.Authorization = `Bearer ${data.data.access}`;
          return api(original);
        } catch (err) {
          processQueue(err, null);
          auth.clearAuth();
          navigateTo("/auth/login");
          return Promise.reject(err);
        } finally {
          isRefreshing = false;
        }
      }

      return Promise.reject(error);
    }
  );

  return api;
}
